<div class="modal-header">
    <h4 class="modal-title">Orders</h4>
</div>
<div class="modal-body" (keyup.esc)="close()">
    <dx-data-grid #dataGrid  height="300" [dataSource]="orders" keyExpr="id" [columnAutoWidth]="false">
        <dxi-column dataField="invoiceNumber" caption="Invoice #" width="80"></dxi-column>
        <dxi-column dataField="status.name" caption="Status" width="80"></dxi-column>
        <dxi-column dataField="createDate" caption="Create Date" dataType="date" width="100"></dxi-column>

        <dxo-selection [mode]="'single'"></dxo-selection>
    </dx-data-grid>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="select()">Select</button>
    <button type="button" class="btn btn-light" (click)="close()">Cancel</button>
</div>
